export const buttonConfig = {
  colorScheme: {
    light: {
      success: {
        color: "white",
        background: "#16a34a",
        border: {
          color: "#16a34a",
        },
        hover: {
          background: "#16a34a",
          border: {
            color: "#16a34a",
          },
        },
        active: {
          background: "#16a34a",
        },
      },
    },
  },
};
